import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { from, Observable } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(
    private httpClient: HttpClient,
    private toastController: ToastController,
    private alertController: AlertController,
    private loadingController: LoadingController
  ) {}

  showToast(message: string) {
    return from(
      this.toastController.create({
        message: message,
        duration: 3500,
        buttons: [
          {
            side: 'end',
            icon: 'close',
            role: 'cancel',
          },
        ],
      })
    ).pipe(concatMap((toast) => toast.present()));
  }

  showAlert(message: string, errors: any[] = []) {
    return from(
      this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Information',
        subHeader: message,
        message: errors.map((v) => v.message).join('\n'),
        backdropDismiss: true,
        buttons: ['OK'],
      })
    ).pipe(concatMap((alert) => alert.present()));
  }

  async showError(message: string) {
    let errorFlag = false;
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Information',
      subHeader: 'Unable to process the request',
      message: message,
      backdropDismiss: true,
      buttons: ['OK'],
    });

    await alert.present();
    await alert.onDidDismiss().then((data) => {});

    return errorFlag;
  }

  // NOTE: Not used yet
  getUsers(): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.baseApiUrl}/users/getByProfile`
    );
  }

  getAsset(uri: string) {
    return this.httpClient.get<any>(uri, {
      responseType: 'blob' as 'json',
    });
  }

  getCountries(): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.baseApiUrl}/countries/getQuery`,
      null
    );
  }

  showLoading(message: string) {
    return from(
      this.loadingController.create({
        message: message,
        backdropDismiss: false,
      })
    ).pipe(
      tap((loading) => {
        loading.present();
      })
    );
  }

  getAssetWithFileName(uri: string) {
    return this.httpClient.get<any>(uri, {
      responseType: 'blob' as 'json',
      observe: 'response',
    });
  }
}
